import React, { lazy, memo } from 'react';
import { Switch, Route } from 'react-router-dom';

const Dashboard = lazy(() => import('../views/OrganizationDashboard'));

const OrganizationRouts = ({ url }) => (
  <Switch>
    <Route path={url}>
      <Dashboard url={url} />
    </Route>
  </Switch>
);

export default memo(OrganizationRouts);
